export default __webpack_public_path__ + "static/media/empty_cart_item.95bc4bda.svg";